"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_SigilOfTheDamkenEffectHandler = exports.Passive_SigilOfTheDamkenEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_SigilOfTheDamkenEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Passive_SigilOfTheDamken;
        this.__typeName = "Passive_SigilOfTheDamken";
        this.name = "Sigil of the Damken";
        this.harmful = false;
    }
}
exports.Passive_SigilOfTheDamkenEffectArgs = Passive_SigilOfTheDamkenEffectArgs;
let Passive_SigilOfTheDamkenEffectHandler = class Passive_SigilOfTheDamkenEffectHandler {
    apply(sequence, container, state) {
        state.meta.attributeIncreaseEffectIds = [
            container.applyBuff({
                sequence,
                creatorId: state.creatorId,
                targetId: state.targetId,
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
                effect: new _1.LinkedEffectsEffectArgs(Array.from(enums_1.PRIMARY_ATTRIBUTES, attr => new _1.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(state.targetId, 4, attr))), false)
            })
        ];
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.attributeIncreaseEffectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
Passive_SigilOfTheDamkenEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_SigilOfTheDamken)
], Passive_SigilOfTheDamkenEffectHandler);
exports.Passive_SigilOfTheDamkenEffectHandler = Passive_SigilOfTheDamkenEffectHandler;
